import { render, staticRenderFns } from "./CollInfo.vue?vue&type=template&id=148d05fe&scoped=true"
import script from "./CollInfo.vue?vue&type=script&lang=js"
export * from "./CollInfo.vue?vue&type=script&lang=js"
import style0 from "./CollInfo.vue?vue&type=style&index=0&id=148d05fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d05fe",
  null
  
)

export default component.exports